/*
 * Copyright (c) 2019. Botanická zahrada Přírodovědecké fakulty Univerzity Karlovy, Juraj Šimon
 */

import Article from "./article";

export default {
  get() {
    return Article.getByTag("notification");
  }
};
